// Keep the current line near the upper reading position without queuing native smooth scrolls.
export function animateLyricScroll(box, target, { reduced = false, duration = 420, interrupted = () => false } = {}) {
  const end = Math.max(0, target);
  const start = box.scrollTop;
  if (reduced || Math.abs(end - start) < 2) {
    box.scrollTop = end;
    return () => {};
  }
  let frame = 0;
  let origin;
  let stopped = false;
  function step(now) {
    if (stopped || interrupted() || !box.isConnected) return;
    origin ??= now;
    const t = Math.min(1, (now - origin) / duration);
    const eased = t * t * (3 - 2 * t);
    box.scrollTop = start + (end - start) * eased;
    if (t < 1) frame = requestAnimationFrame(step);
  }
  frame = requestAnimationFrame(step);
  return () => { stopped = true; cancelAnimationFrame(frame); };
}
